// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.offerlist-container {
    border-radius: 10px;
    border: 1px solid #ddd;
    padding: 20px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    width: 100%;
    margin-bottom: 20px;
}

.dark .offerlist-container{
    color: white;
    background-color: var(--dark-blue);
}

.available-offer-text{
text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/twoWaykeyboardPaymentPage/components/offerCheckModal/components/availableOffer/index.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,wCAAwC;IACxC,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,kCAAkC;AACtC;;AAEA;AACA,0BAA0B;AAC1B","sourcesContent":[".offerlist-container {\n    border-radius: 10px;\n    border: 1px solid #ddd;\n    padding: 20px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    width: 100%;\n    margin-bottom: 20px;\n}\n\n.dark .offerlist-container{\n    color: white;\n    background-color: var(--dark-blue);\n}\n\n.available-offer-text{\ntext-decoration: underline;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
